module.exports = __webpack_public_path__ + "static/media/bf109.7e611eba.jpg";